import { all } from "redux-saga/effects";

import allVendorSagas from "./allVendors";
import crudVendorSagas from "./crudVendor";

export default function* vendorSagas() {
  yield all([allVendorSagas(), crudVendorSagas()]);
}
